import { render, staticRenderFns } from "./edit-feedback-settings.vue?vue&type=template&id=37e1d4ac&scoped=true&"
import script from "./edit-feedback-settings.vue?vue&type=script&lang=ts&"
export * from "./edit-feedback-settings.vue?vue&type=script&lang=ts&"
import style0 from "./edit-feedback-settings.vue?vue&type=style&index=0&id=37e1d4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1d4ac",
  null
  
)

export default component.exports